import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  // capitalize for one word
  function capitalize(word: string): string {
    const wordLowerCase = word.toLowerCase();
    return wordLowerCase.charAt(0).toUpperCase() + wordLowerCase.slice(1);
  }

  return {
    capitalize,
  };
}
